/* ECLINEA - animations d'images désactivées (parallax, inclinaison, reflets, zoom plein écran). */

/* ECLINEA - correctif galerie produit v5 : la galerie suit la couleur choisie sans recharger la page, et la page ne saute pas.
   - On surveille ?variant= ; quand il change, on redemande la page et on remplace la galerie si elle diffère.
   - Pendant 2 s après un changement de couleur, tout défilement automatique de la page est bloqué (et tracé dans la console : [ecl]). */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var last = new URL(location.href).searchParams.get('variant');
  var timer;
  var token = 0;
  var lock = null;
  var internal = false;

  function locked() { return !!(lock && lock.on && !internal); }
  function trace(what) { try { console.info('[ecl] défilement bloqué :', what, new Error().stack); } catch (e) {} }

  ['scrollTo', 'scrollBy', 'scroll'].forEach(function (name) {
    var orig = window[name];
    if (typeof orig !== 'function') return;
    window[name] = function () {
      if (locked()) { trace('window.' + name); return; }
      return orig.apply(window, arguments);
    };
  });
  var origIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (locked()) { trace('scrollIntoView'); return; }
    return origIntoView.apply(this, arguments);
  };
  var origFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (opts) {
    if (lock && lock.on) {
      opts = Object.assign({}, opts || {}, { preventScroll: true });
    }
    return origFocus.call(this, opts);
  };

  function startLock() {
    var l = { x: window.scrollX, y: window.scrollY, on: true };
    if (lock) lock.on = false;
    lock = l;
    setTimeout(function () { l.on = false; }, 2000);
  }
  function stopLock() { if (lock) lock.on = false; }
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, stopLock, { passive: true });
  });
  window.addEventListener('scroll', function () {
    if (!lock || !lock.on) return;
    if (Math.abs(window.scrollY - lock.y) > 4) {
      console.info('[ecl] saut de page détecté, retour à', lock.y, '(était', window.scrollY + ')');
      internal = true;
      try { window.scrollTo({ left: lock.x, top: lock.y, behavior: 'instant' }); } finally { internal = false; }
    }
  }, { passive: true });

  function signature(gallery) {
    var out = [];
    gallery.querySelectorAll('img').forEach(function (img) {
      out.push((img.getAttribute('src') || '') + '|' + (img.getAttribute('srcset') || '') + '|' + (img.getAttribute('data-src') || ''));
    });
    return out.join('~').replace(/\?v=\d+/g, '').replace(/&amp;/g, '&');
  }
  function swap(cur, next) {
    var parent = cur.parentElement;
    var h = cur.offsetHeight;
    var root = document.documentElement;
    var prevAnchor = root.style.overflowAnchor;
    root.style.overflowAnchor = 'none';
    if (parent && h) parent.style.minHeight = h + 'px';
    cur.replaceWith(document.importNode(next, true));
    setTimeout(function () {
      if (parent) parent.style.minHeight = '';
      root.style.overflowAnchor = prevAnchor;
    }, 700);
  }
  function sync() {
    var variant = new URL(location.href).searchParams.get('variant');
    if (!variant || !document.querySelector('media-gallery')) return;
    var mine = ++token;
    fetch(location.pathname + '?variant=' + encodeURIComponent(variant), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mine !== token) return;
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('media-gallery');
        var cur = document.querySelector('media-gallery');
        if (!next || !cur) return;
        if (signature(cur) === signature(next)) return;
        swap(cur, next);
      })
      .catch(function () {});
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 600);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-picker')) {
      startLock();
      schedule();
    }
  });
  setInterval(function () {
    var v = new URL(location.href).searchParams.get('variant');
    if (v !== last) {
      last = v;
      if (!lock || !lock.on) startLock();
      schedule();
    }
  }, 400);
})();
